module.exports = __webpack_public_path__ + "img/744.72197eea.jpg";